<template lang="pug">
  .h-100vh.bg-white.overflow-hidden(:style="'height:' + viewerHeight + 'px'")
    transition(name="fade")
      slider(v-if="renderSlider",
      :portraitMode="portraitMode",
      :projects="projects",
      :selectedID="selectedID",
      :showFooter="showFooter",
      :height="viewerHeight",
      @showThumbs="thumbsVisible = true",
      v-bind="$attrs",
      v-on="$listeners")
</template>

<script>
import Slider from '@/components/SeriesViewer__Slider'
const getPortraitMode = () => window.innerWidth / window.innerHeight < 1.2
export default {
  name: 'Viewer',
  props: ['projects', 'selectedID', 'showFooter', 'introScroll'],
  components: { Slider },
  data () {
    return {
      renderSlider: true,
      portraitMode: getPortraitMode(),
      afterResize: null,
      viewerHeight: window.innerHeight,
      lastWinW: window.innerWidth
    }
  },
  methods: {
    reloadSlider () {
      this.renderSlider = false
      setTimeout(() => { this.renderSlider = true }, 600) // after fade transition
    },
    onResize () {
      // update viewer height ?
      const winW = window.innerWidth
      const winH = window.innerHeight
      // if winW changed or viewer is taller than winH (to minimize it changing on ios scroll...)
      if (this.lastWinW !== winW || this.viewerHeight > winH) {
        requestAnimationFrame(() => {
          this.viewerHeight = winH
        })
      }
      this.lastWinW = winW
      // after resize, set is portrait mode
      clearTimeout(this.afterResize)
      this.afterResize = setTimeout(() => {
        const mode = getPortraitMode()
        if (mode !== this.portraitMode) {
          this.portraitMode = mode
          return this.reloadSlider()
        }
      }, 200)
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SeriesViewer.vue